import InputWithButton from '../../../common/interactive/InputWithButton'
import classes from './PaginationGoTo.module.css'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { filterActions } from '../../../../store/filter'
import { historyActions } from '../../../../store/history'
import { exportsActions } from '../../../../store/exports'
import { referralsActions } from '../../../../store/referrals'
import { tasksActions } from '../../../../store/tasks'
import { transfersActions } from '../../../../store/transfers'
import { appointmentsActions } from '../../../../store/appointments'


const SLICE_ACTIONS = {
    history: historyActions,
    exports: exportsActions,
    referrals: referralsActions,
    tasks: tasksActions,
    transfers: transfersActions,
    appointments: appointmentsActions,
}

export default function PaginationGoTo({data, apiType}) {
    const dispatch = useDispatch()
    const [defaultValue, setDefaultValue] = useState(data.meta.current_page)


    const loading = useSelector(state => state[SLICE_ACTIONS[apiType] ? apiType : 'filter'].loading)
    let requesterId = 'page_requester_id_GoTo'
    const requesterIdStored = useSelector(state => state[SLICE_ACTIONS[apiType] ? apiType : 'filter'].requesterId)


    let typingTimer;                //timer identifier
    const doneTypingInterval = 1500;  //time in ms,

    function setproperPage(pageValue) {
        let page = Math.abs(pageValue)
        if (page == 0) {
            page = 1
        }
        if (page > data.meta.last_page) {
            page = data.meta.last_page
        }
        return page
    }

    const handleKeyDown = (event) => {
        clearTimeout(typingTimer);
        if (event.key == 'Enter' && event.target.value !== '') {
            let page = setproperPage(event.target.value)
            setDefaultValue(page)
            goToPageHandler(page)
        }
    }

    const handleChange = (event) => {
        let page = setproperPage(event.target.value)
        setDefaultValue(page)
    }

    const keyUpFunction = (event) => {
        if (event.target.value !== '') {
            let page = setproperPage(event.target.value)
            setDefaultValue(page)

            if (event.key === 'Enter') {
                clearTimeout(typingTimer)
                return
            }

            clearTimeout(typingTimer)
            typingTimer = setTimeout(goToPageHandler.bind(null, page), doneTypingInterval)
        }
    }

    const goToPageHandler = async (value) => {
        if (value) {
            let page = Math.abs(value)
    
            
            if (apiType == 'history') {
                dispatch(historyActions.setCurrentPage(page))
                dispatch(historyActions.setRequesterId(requesterId))
            } else if (apiType == 'exports') {
                dispatch(exportsActions.setCurrentPage(page))
                dispatch(exportsActions.setRequesterId(requesterId))
            } else if (apiType == 'referrals') {
                dispatch(referralsActions.setCurrentPage(page))
                dispatch(referralsActions.setRequesterId(requesterId))
            } else if (apiType == 'tasks') {
                dispatch(tasksActions.setCurrentPage(page))
                dispatch(tasksActions.setRequesterId(requesterId))
            } else if (apiType == 'transfers') {
                dispatch(transfersActions.setCurrentPage(page))
                dispatch(transfersActions.setRequesterId(requesterId))
            } else if (apiType == 'appointments') {
                dispatch(appointmentsActions.setCurrentPage(page))
                dispatch(appointmentsActions.setRequesterId(requesterId))
            } else {
                dispatch(filterActions.setCurrentPage(page))
                dispatch(filterActions.setRequesterId(requesterId))
            }

        }
    }

    useEffect(() => {
        setDefaultValue(data.meta.current_page)
    }, [data.meta.current_page])

    return <div className={classes.page_info}>
        {loading && requesterIdStored == requesterId && <span className={`loader dark`}></span>}
        <span>Page:</span>
        <input type="number" name="page" value={defaultValue} min={1} max={data.meta.last_page} className={classes.input} onKeyDown={handleKeyDown} onChange={handleChange} onKeyUp={keyUpFunction}/>      
        <span>of</span>
        <span>{data.meta.last_page}</span>
    </div>
}